import Swiper from "swiper";
import { Navigation, FreeMode, Keyboard } from "swiper/modules";

// Timeline Carousel (bskr/timeline-carousel). Swiper-driven horizontal
// milestone timeline. Replaces the production jQuery-scroll + AOS version.
// Reveal uses a lightweight IntersectionObserver (no GSAP in this per-block
// bundle); reduced motion shows everything immediately.

function start() {
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}

function init() {
  const blocks = document.querySelectorAll("[data-component='timeline-carousel']");
  if (!blocks.length) return;

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  blocks.forEach((block) => {
    if (block.dataset.timelineInited === "1") return;
    block.dataset.timelineInited = "1";

    const viewport = block.querySelector(".swiper");
    if (!viewport) return;

    const prev = block.querySelector(".swiper-button-prev");
    const next = block.querySelector(".swiper-button-next");
    const slides = viewport.querySelectorAll(".swiper-slide");
    if (!slides.length) return;

    // eslint-disable-next-line no-new
    new Swiper(viewport, {
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: false,
      grabCursor: true,
      watchOverflow: true,
      speed: 600,
      keyboard: { enabled: true },
      navigation: { prevEl: prev, nextEl: next },
      breakpoints: {
        768: { slidesPerView: 2.2, spaceBetween: 30 },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 30,
          freeMode: { enabled: true, sticky: true },
        },
      },
      modules: [Navigation, FreeMode, Keyboard],
    });

    if (reduce) {
      slides.forEach((s) => s.classList.add("is-revealed"));
      return;
    }

    // Flag the carousel so the pre-reveal (hidden) state applies; without this
    // class the cards stay visible (no-JS / failed observer safety).
    block.classList.add("is-reveal-ready");

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );
    slides.forEach((s) => io.observe(s));
  });
}
